/* Auto-enable availability filter to show only in-stock products */
(function() {
  'use strict';

  // Function to check the availability filter
  function enableAvailabilityFilter() {
    // Find all availability filter checkboxes (both mobile and desktop)
    const availabilityCheckboxes = document.querySelectorAll('input[name="filter.v.availability"][value="1"]');
    
    availabilityCheckboxes.forEach(checkbox => {
      if (!checkbox.checked) {
        checkbox.checked = true;
        
        // Trigger change event to update the collection
        const event = new Event('change', { bubbles: true });
        checkbox.dispatchEvent(event);
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableAvailabilityFilter);
  } else {
    enableAvailabilityFilter();
  }

  // Also run after a slight delay to ensure Shopify's filtering JS has initialized
  setTimeout(enableAvailabilityFilter, 500);

  // Re-enable after filter changes (in case Shopify's code unchecks it)
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[type="checkbox"]') && 
        e.target.name !== 'filter.v.availability') {
      // Another filter was changed, ensure availability stays checked
      setTimeout(enableAvailabilityFilter, 100);
    }
  });

  // Handle dynamic content updates (for AJAX-loaded collections)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        enableAvailabilityFilter();
      }
    });
  });

  // Observe the collection grid for changes
  const collectionGrid = document.querySelector('.collection-product-grid, [data-collection-grid], .product-grid');
  if (collectionGrid) {
    observer.observe(collectionGrid.parentElement, {
      childList: true,
      subtree: true
    });
  }
})();